.plan-type-step{display:flex;flex-direction:column;gap:24px;max-width:480px}
/*# sourceMappingURL=plan-type-step.component-WV5H5PVZ.css.map */
